import { render, staticRenderFns } from "./TopicAnswer.vue?vue&type=template&id=739fc116&scoped=true"
import script from "./TopicAnswer.vue?vue&type=script&lang=js"
export * from "./TopicAnswer.vue?vue&type=script&lang=js"
import style0 from "./TopicAnswer.vue?vue&type=style&index=0&id=739fc116&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739fc116",
  null
  
)

export default component.exports